import { VintageModel as AdminVintageModel } from "@vini-wine/admin-core-models";
import { VintageModel as OfferVintageModel } from "@vini-wine/offer-core-models";
import { VintageModel as ContentVintageModel } from "@vini-wine/content-core-models";
import { VintageModel as AnalyticVintageModel } from "@vini-wine/analytic-core-models";

type VintageModels =
  | AdminVintageModel
  | OfferVintageModel
  | ContentVintageModel
  | AnalyticVintageModel;

export const getVintageNameConvention = (vintage: VintageModels): string => {
  const vintageWine = vintage.wine;
  const vintageRegion = vintageWine?.region;
  let vintageWineRegionCountry = undefined;
  if (vintageRegion && "country" in vintageRegion) {
    vintageWineRegionCountry = vintageRegion?.country;
  }

  const wineryName = vintageWine?.winery?.name;
  const wineName = vintageWine?.name;
  const wineTypeName = vintageWine?.wineType?.name;
  const vintageYear = vintage.year;
  const wineRegionName = vintageRegion?.name;
  const countryName = vintageWineRegionCountry
    ? `, ${vintageWineRegionCountry.name}`
    : "";

  return `${wineryName} ${wineName} ${wineTypeName} ${vintageYear}, ${wineRegionName}${countryName}`;
};
